import { render, staticRenderFns } from "./about_us_content.vue?vue&type=template&id=22223ce0"
import script from "./about_us_content.vue?vue&type=script&lang=js"
export * from "./about_us_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports